module.exports = __webpack_public_path__ + "61b231caf1fdeedc95cea55aa54d078f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Asscher.png
// module id = 773
// module chunks = 0